/* BaseBlocks collection hub (/pages/collection) -- shared behaviour for all
   bb-collection-* sections (mode switch, filter/sort, same-page anchors).
   Loaded once from page.collection.liquid. */
(() => {
  const modeButtons = [...document.querySelectorAll('.shop-mode-btn')];
  const panels = [...document.querySelectorAll('.shop-mode-panel')];
  const navSets = [...document.querySelectorAll('.collection-nav-set')];
  const grid = document.getElementById('d-productGrid');
  const sort = document.querySelector('.sort');
  const chips = [...document.querySelectorAll('.chip')];
  const cards = grid ? [...grid.querySelectorAll('.product-card')] : [];
  const featuredOrder = [...cards];

  function matches(card, filter) {
    if (filter === 'all') return true;
    if (filter === 'pressing') return card.dataset.family === 'dip' || card.dataset.family === 'parallettes';
    return card.dataset.family === filter;
  }
  function applySort(value) {
    if (!grid) return;
    let visible = cards.filter(card => !card.classList.contains('is-hidden'));
    if (value === 'low') visible.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
    else if (value === 'high') visible.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
    else visible = featuredOrder.filter(card => visible.includes(card));
    visible.forEach(card => grid.appendChild(card));
  }
  function applyFilter(filter) {
    cards.forEach(card => card.classList.toggle('is-hidden', !matches(card, filter)));
    chips.forEach(chip => chip.classList.toggle('active', chip.dataset.filter === filter));
    applySort(sort ? sort.value : 'featured');
  }
  function setMode(mode, updateHash = false) {
    if (mode !== 'choose' && mode !== 'browse') return;
    modeButtons.forEach(btn => {
      const active = btn.dataset.shopMode === mode;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach(panel => {
      const active = panel.dataset.shopMode === mode;
      panel.hidden = !active;
      panel.classList.toggle('active', active);
    });
    navSets.forEach(set => {
      const active = set.dataset.navMode === mode;
      set.hidden = !active;
      set.classList.toggle('active', active);
    });
    document.body.dataset.shopMode = mode;
    if (updateHash) history.replaceState(null,'',mode === 'browse' ? '#browse' : '#choose');
  }

  modeButtons.forEach(btn => btn.addEventListener('click', () => setMode(btn.dataset.shopMode, true)));
  chips.forEach(chip => chip.addEventListener('click', () => applyFilter(chip.dataset.filter)));
  if (sort) sort.addEventListener('change', e => applySort(e.target.value));

  document.querySelectorAll('[data-browse-filter]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      setMode('browse');
      applyFilter(link.dataset.browseFilter);
      document.getElementById('all')?.scrollIntoView({behavior:'smooth',block:'start'});
    });
  });

  const guidedIds = new Set(['choose','pullup','stations','pressing','lower']);
  function syncModeToHash() {
    const id = location.hash.replace('#','');
    if (id === 'browse' || id === 'all') setMode('browse');
    else if (guidedIds.has(id)) setMode('choose');
  }
  window.addEventListener('hashchange', syncModeToHash);
  syncModeToHash();
})();

const modeBtns=[...document.querySelectorAll('.mode-btn')];
const panels=[...document.querySelectorAll('.mode-panel')];
function setMode(mode,scroll=false){
  modeBtns.forEach(b=>b.classList.toggle('active',b.dataset.mode===mode));
  panels.forEach(p=>{const active=p.dataset.mode===mode; p.classList.toggle('active',active); if(active){p.classList.remove('mode-fade');void p.offsetWidth;p.classList.add('mode-fade')}});
  try{sessionStorage.setItem('bbCollectionMode',mode)}catch(e){}
  if(scroll){document.querySelector('.mode-wrap').scrollIntoView({behavior:'smooth',block:'start'})}
}
modeBtns.forEach(b=>b.addEventListener('click',()=>setMode(b.dataset.mode,true)));
try{const saved=sessionStorage.getItem('bbCollectionMode');if(saved==='browse')setMode('browse',false)}catch(e){}
const chips=[...document.querySelectorAll('.chip')], cards=[...document.querySelectorAll('.browse-card')], grid=document.getElementById('m-browseGrid'), sort=document.querySelector('.sort');
let activeFilter='all';
function filterProducts(f){activeFilter=f;chips.forEach(c=>c.classList.toggle('active',c.dataset.filter===f));cards.forEach(c=>c.classList.toggle('hidden',!(f==='all'||c.dataset.family===f)))}
chips.forEach(c=>c.addEventListener('click',()=>filterProducts(c.dataset.filter)));
document.querySelectorAll('[data-browse-filter]').forEach(a=>a.addEventListener('click',()=>{filterProducts(a.dataset.browseFilter)}));
sort.addEventListener('change',()=>{const visible=[...cards]; if(sort.value==='low')visible.sort((a,b)=>+a.dataset.price-+b.dataset.price); if(sort.value==='high')visible.sort((a,b)=>+b.dataset.price-+a.dataset.price); visible.forEach(c=>grid.appendChild(c))});


/* Same-page anchor resolver: nav links / category tiles use plain
   fragments (#pullup, #stations, ...). Each breakpoint's real section id is
   prefixed (d-/m-) to avoid duplicate ids now that both variants sit in the
   DOM together (shown/hidden by CSS only). This resolves a plain hash to
   whichever prefixed element is currently visible and scrolls to it. */
(function () {
  var SECTION_IDS = ['choose', 'pullup', 'stations', 'pressing', 'lower', 'accessories', 'air', 'all'];

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function resolveTarget(name) {
    var d = document.getElementById('d-' + name);
    var m = document.getElementById('m-' + name);
    if (isVisible(d)) return d;
    if (isVisible(m)) return m;
    return d || m || null;
  }

  function handleHash() {
    var name = (location.hash || '').replace('#', '');
    if (SECTION_IDS.indexOf(name) === -1) return;
    var target = resolveTarget(name);
    if (target) target.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[href^="#"]');
    if (!a) return;
    var name = a.getAttribute('href').slice(1);
    if (SECTION_IDS.indexOf(name) === -1) return;
    var target = resolveTarget(name);
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + name);
    }
  });

  window.addEventListener('hashchange', handleHash);
  if (location.hash) {
    window.addEventListener('load', function () { setTimeout(handleHash, 0); });
  }
})();



(function () {
  var nav = document.querySelector('.collection-nav');
  if (!nav) return;
  // The theme's own site header is ALSO pinned to the top of the viewport
  // (`#shopify-section-header{position:sticky;top:0;z-index:101}` in the
  // theme's base CSS) -- so simply fixing this bar to `top:0` too made it
  // land in the exact same spot as the header and disappear behind it
  // (the header's higher z-index wins), which is what looked like "not
  // sticking" once you scrolled past it. This measures the header's real,
  // current height on every update and docks the bar directly beneath it
  // instead of at the very top, and re-measures on every scroll/resize so
  // it still lines up correctly even if the header's height ever changes
  // (e.g. an announcement bar collapsing).
  var header = document.getElementById('shopify-section-header');
  var placeholder = document.createElement('div');
  placeholder.style.display = 'none';
  nav.parentNode.insertBefore(placeholder, nav);
  var naturalTop = null;

  function headerHeight() {
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  }
  function measure() {
    var wasFixed = nav.classList.contains('bb-nav-fixed');
    if (wasFixed) { nav.classList.remove('bb-nav-fixed'); placeholder.style.display = 'none'; }
    naturalTop = nav.getBoundingClientRect().top + window.pageYOffset;
    if (wasFixed) update();
  }
  function update() {
    if (naturalTop === null) return;
    var shouldFix = window.pageYOffset >= naturalTop;
    if (shouldFix) {
      if (!nav.classList.contains('bb-nav-fixed')) {
        placeholder.style.height = nav.offsetHeight + 'px';
        placeholder.style.display = 'block';
        nav.classList.add('bb-nav-fixed');
      }
      nav.style.top = headerHeight() + 'px';
    } else if (nav.classList.contains('bb-nav-fixed')) {
      nav.classList.remove('bb-nav-fixed');
      nav.style.top = '';
      placeholder.style.display = 'none';
    }
  }

  measure();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function () { measure(); update(); });
})();

